
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const stats = [
    { label: '系统用户', value: '8,456', icon: 'ri-user-line', color: 'bg-blue-500', change: '+12%' },
    { label: '活跃项目', value: '1,234', icon: 'ri-file-list-line', color: 'bg-green-500', change: '+8%' },
    { label: '今日访问', value: '23,567', icon: 'ri-eye-line', color: 'bg-purple-500', change: '+15%' },
    { label: '系统告警', value: '3', icon: 'ri-alert-line', color: 'bg-red-500', change: '-2' }
  ];

  const recentUsers = [
    { id: 1, name: '张三', company: '建设集团有限公司', role: '采购方', status: '已认证', time: '2024-01-15 10:30' },
    { id: 2, name: '李四', company: '工程建设股份公司', role: '投标方', status: '待审核', time: '2024-01-15 09:45' },
    { id: 3, name: '王五', company: '建筑设计研究院', role: '评审专家', status: '已认证', time: '2024-01-15 08:20' },
    { id: 4, name: '赵六', company: '监理咨询有限公司', role: '监督方', status: '已认证', time: '2024-01-14 16:55' },
    { id: 5, name: '钱七', company: '科技发展有限公司', role: '投标方', status: '待审核', time: '2024-01-14 15:30' }
  ];

  const systemLogs = [
    { id: 1, action: '用户登录', user: '张三', ip: '192.168.1.100', time: '2024-01-15 10:30:25', status: 'success' },
    { id: 2, action: '项目创建', user: '李四', ip: '192.168.1.101', time: '2024-01-15 10:25:18', status: 'success' },
    { id: 3, action: '文件上传', user: '王五', ip: '192.168.1.102', time: '2024-01-15 10:20:45', status: 'success' },
    { id: 4, action: '登录失败', user: '未知', ip: '192.168.1.103', time: '2024-01-15 10:15:32', status: 'error' },
    { id: 5, action: '权限修改', user: '管理员', ip: '192.168.1.1', time: '2024-01-15 10:10:15', status: 'warning' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button onClick={() => navigate('/')} className="text-gray-600 hover:text-gray-900 cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-purple-500 rounded-lg flex items-center justify-center">
                  <i className="ri-admin-line text-xl text-white"></i>
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-900">系统管理员工作台</h1>
                  <p className="text-sm text-gray-500">管理员：admin</p>
                </div>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <button className="px-4 py-2 text-gray-600 hover:text-gray-900 whitespace-nowrap cursor-pointer">
                <i className="ri-notification-line text-xl"></i>
              </button>
              <button className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 whitespace-nowrap cursor-pointer">
                <i className="ri-settings-3-line mr-2"></i>
                系统设置
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="p-6">
        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
              <div className="flex items-center justify-between mb-4">
                <div className={`w-12 h-12 ${stat.color} rounded-lg flex items-center justify-center`}>
                  <i className={`${stat.icon} text-2xl text-white`}></i>
                </div>
                <span className={`text-sm font-semibold ${stat.change.startsWith('+') ? 'text-green-600' : 'text-red-600'}`}>
                  {stat.change}
                </span>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-1">{stat.value}</div>
              <div className="text-sm text-gray-500">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-xl shadow-sm mb-6">
          <div className="border-b border-gray-200 px-6">
            <div className="flex space-x-8">
              {[
                { id: 'overview', label: '概览', icon: 'ri-dashboard-line' },
                { id: 'users', label: '用户管理', icon: 'ri-user-settings-line' },
                { id: 'logs', label: '系统日志', icon: 'ri-file-list-3-line' },
                { id: 'settings', label: '系统配置', icon: 'ri-settings-4-line' }
              ].map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer transition-colors ${
                    activeTab === tab.id
                      ? 'border-purple-600 text-purple-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700'
                  }`}
                >
                  <i className={`${tab.icon} mr-2`}></i>
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          <div className="p-6">
            {activeTab === 'overview' && (
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-4">系统概览</h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-6">
                      <div className="text-sm text-blue-600 font-semibold mb-2">今日新增用户</div>
                      <div className="text-3xl font-bold text-blue-900">156</div>
                    </div>
                    <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg p-6">
                      <div className="text-sm text-green-600 font-semibold mb-2">今日新增项目</div>
                      <div className="text-3xl font-bold text-green-900">42</div>
                    </div>
                    <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg p-6">
                      <div className="text-sm text-purple-600 font-semibold mb-2">系统运行时间</div>
                      <div className="text-3xl font-bold text-purple-900">365天</div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'users' && (
              <div>
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-lg font-bold text-gray-900">用户管理</h3>
                  <div className="flex items-center space-x-3">
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="搜索用户..."
                        className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                      />
                      <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                    </div>
                    <button className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 whitespace-nowrap cursor-pointer">
                      <i className="ri-add-line mr-2"></i>
                      添加用户
                    </button>
                  </div>
                </div>
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead>
                      <tr className="border-b border-gray-200">
                        <th className="text-left py-3 px-4 text-sm font-semibold text-gray-600">用户名称</th>
                        <th className="text-left py-3 px-4 text-sm font-semibold text-gray-600">所属单位</th>
                        <th className="text-left py-3 px-4 text-sm font-semibold text-gray-600">角色</th>
                        <th className="text-left py-3 px-4 text-sm font-semibold text-gray-600">状态</th>
                        <th className="text-left py-3 px-4 text-sm font-semibold text-gray-600">注册时间</th>
                        <th className="text-left py-3 px-4 text-sm font-semibold text-gray-600">操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      {recentUsers.map((user) => (
                        <tr key={user.id} className="border-b border-gray-100 hover:bg-gray-50">
                          <td className="py-4 px-4">
                            <div className="flex items-center space-x-3">
                              <div className="w-10 h-10 bg-gradient-to-br from-purple-400 to-purple-600 rounded-full flex items-center justify-center text-white font-semibold">
                                {user.name.charAt(0)}
                              </div>
                              <span className="font-medium text-gray-900">{user.name}</span>
                            </div>
                          </td>
                          <td className="py-4 px-4 text-gray-600">{user.company}</td>
                          <td className="py-4 px-4">
                            <span className="inline-block px-3 py-1 bg-blue-100 text-blue-700 text-xs font-semibold rounded-full whitespace-nowrap">
                              {user.role}
                            </span>
                          </td>
                          <td className="py-4 px-4">
                            <span className={`inline-block px-3 py-1 text-xs font-semibold rounded-full whitespace-nowrap ${
                              user.status === '已认证' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'
                            }`}>
                              {user.status}
                            </span>
                          </td>
                          <td className="py-4 px-4 text-gray-600 text-sm">{user.time}</td>
                          <td className="py-4 px-4">
                            <div className="flex items-center space-x-2">
                              <button className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg cursor-pointer whitespace-nowrap">
                                <i className="ri-edit-line"></i>
                              </button>
                              <button className="p-2 text-red-600 hover:bg-red-50 rounded-lg cursor-pointer whitespace-nowrap">
                                <i className="ri-delete-bin-line"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {activeTab === 'logs' && (
              <div>
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-lg font-bold text-gray-900">系统日志</h3>
                  <div className="flex items-center space-x-3">
                    <select className="px-4 py-2 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm cursor-pointer">
                      <option>全部日志</option>
                      <option>成功</option>
                      <option>警告</option>
                      <option>错误</option>
                    </select>
                    <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 whitespace-nowrap cursor-pointer">
                      <i className="ri-download-line mr-2"></i>
                      导出日志
                    </button>
                  </div>
                </div>
                <div className="space-y-3">
                  {systemLogs.map((log) => (
                    <div key={log.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                      <div className="flex items-center space-x-4 flex-1">
                        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                          log.status === 'success' ? 'bg-green-100' :
                          log.status === 'warning' ? 'bg-yellow-100' : 'bg-red-100'
                        }`}>
                          <i className={`${
                            log.status === 'success' ? 'ri-checkbox-circle-line text-green-600' :
                            log.status === 'warning' ? 'ri-error-warning-line text-yellow-600' :
                            'ri-close-circle-line text-red-600'
                          } text-xl`}></i>
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center space-x-3 mb-1">
                            <span className="font-semibold text-gray-900">{log.action}</span>
                            <span className="text-sm text-gray-500">用户: {log.user}</span>
                            <span className="text-sm text-gray-500">IP: {log.ip}</span>
                          </div>
                          <div className="text-sm text-gray-500">{log.time}</div>
                        </div>
                      </div>
                      <button className="p-2 text-gray-400 hover:text-gray-600 cursor-pointer whitespace-nowrap">
                        <i className="ri-more-2-fill"></i>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'settings' && (
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-6">系统配置</h3>
                <div className="space-y-6">
                  <div className="border-b border-gray-200 pb-6">
                    <h4 className="font-semibold text-gray-900 mb-4">基础设置</h4>
                    <div className="space-y-4">
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="font-medium text-gray-900">系统名称</div>
                          <div className="text-sm text-gray-500">设置系统显示名称</div>
                        </div>
                        <input type="text" value="智慧招投标管理系统" className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent" />
                      </div>
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="font-medium text-gray-900">用户注册</div>
                          <div className="text-sm text-gray-500">允许新用户注册</div>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input type="checkbox" className="sr-only peer" defaultChecked />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-purple-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600"></div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="border-b border-gray-200 pb-6">
                    <h4 className="font-semibold text-gray-900 mb-4">安全设置</h4>
                    <div className="space-y-4">
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="font-medium text-gray-900">双因素认证</div>
                          <div className="text-sm text-gray-500">启用双因素身份验证</div>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input type="checkbox" className="sr-only peer" defaultChecked />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-purple-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600"></div>
                        </label>
                      </div>
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="font-medium text-gray-900">登录日志</div>
                          <div className="text-sm text-gray-500">记录用户登录日志</div>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input type="checkbox" className="sr-only peer" defaultChecked />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-purple-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600"></div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end">
                    <button className="px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 whitespace-nowrap cursor-pointer">
                      保存设置
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
